import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
library.add(faArrowAltCircleLeft)

class SingleProject extends Component {
    constructor(props) {
        super(props);
        this.state={
            didMount: false,
            currentPj: [],
        }
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidMount(){
        const { data } = this.props.location.state
        this.setState({
            didMount: true,
            currentPj: data,
        }) 
    }
    render() {
        let ready = this.state.didMount;
        if (ready === false) {
            return (
                <div>
                 <div className="loading-logo"></div>
            </div>
            )
        }
        let currentPro = this.state.currentPj;
        return (
            <Grid className="sgl-prj-contnr">
            <FontAwesomeIcon onClick={this.goBack} icon="arrow-alt-circle-left" className="back-logo" alt="logo" />
                <Row>
                    <Col sm={8}>
                    <img key={currentPro.id} className="single-mockup" src={currentPro.image} alt="project"/>

                    </Col>
                    <Col sm={4} className="right-screen">
                        <h1 className="sgl-title">{currentPro.title}</h1>
                        <hr className="divider"></hr>
                        <br></br>
                        <p>{currentPro.overview}</p>
                        <a className="prjct-lnk" target="blank" href={currentPro.link}><p>{currentPro.link}</p></a>

                    </Col>

                </Row>
            </Grid>
        );
    }
}

export default SingleProject;
